import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const LoadingContext = createContext({
	isLoading: false,
	setLoading: () => {},
});

let externalSetLoading = null;

export const setGlobalLoading = (value) => {
	if (externalSetLoading) {
		externalSetLoading(Boolean(value));
	}
};

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const setLoading = useCallback((value) => setIsLoading(Boolean(value)), []);

	useEffect(() => {
		externalSetLoading = setLoading;
		return () => {
			if (externalSetLoading === setLoading) {
				externalSetLoading = null;
			}
		};
	}, [setLoading]);

	const value = useMemo(() => ({ isLoading, setLoading }), [isLoading, setLoading]);

	return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

LoadingProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const GlobalLoadingSpinner = () => {
	const { isLoading } = useLoading();

	if (!isLoading) return null;

	return (
		<div
			style={{
				position: 'fixed',
				inset: 0,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				background: 'rgba(255, 255, 255, 0.6)',
				zIndex: 20000,
			}}>
			<img
				src={`${process.env.PUBLIC_URL}/image/loading.gif`}
				alt='Loading'
				style={{ width: '90px', height: '90px' }}
			/>
		</div>
	);
};
